import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-fall-bild-scaled';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollFallBildScaledEffects {

    FunkprotokollFallBildScaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_FALL_BILD_SCALED),
        mergeMap((x: ac.GetFunkprotokollFallBildScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollFallBildScaled(x.veranstaltung_id, x.fall_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollFallBildScaledErfolgreichAction(result, x.veranstaltung_id, x.fall_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollFallBildScaledFehlerAction(error, x.veranstaltung_id, x.fall_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
